module.exports = __webpack_public_path__ + "categories/icon-feature-payment-06c6861c34b26d9a7e71f7ca45109d70.svg";